module.exports = function opaquer(color) {
  color.installMethod('opaquer', function (amount) {
    return this.alpha(isNaN(amount) ? 0.1 : amount, true);
  });
};
